import { render, staticRenderFns } from "./FilesUpload.vue?vue&type=template&id=385a7c80&scoped=true&"
import script from "./FilesUpload.vue?vue&type=script&lang=ts&"
export * from "./FilesUpload.vue?vue&type=script&lang=ts&"
import style0 from "./FilesUpload.vue?vue&type=style&index=0&id=385a7c80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385a7c80",
  null
  
)

export default component.exports